import { render, staticRenderFns } from "./PeriodPicker.vue?vue&type=template&id=88943560&scoped=true&"
import script from "./PeriodPicker.vue?vue&type=script&lang=js&"
export * from "./PeriodPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88943560",
  null
  
)

/* custom blocks */
import block0 from "./PeriodPicker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports